import React from "react";
import { Row, Col, Form } from "react-bootstrap";

type TwoWaySwitchProps = {
  leftLabel: React.ReactNode;
  rightLabel: React.ReactNode;
  checked: boolean;
  onChange: (v: boolean) => void;
  switchId?: string;
  direction?: "ltr" | "rtl"; // default ltr
};

const SXTwoWaySwitch: React.FC<TwoWaySwitchProps> = ({
  leftLabel,
  rightLabel,
  checked,
  onChange,
  switchId = "two-way-switch",
  direction: propsDirection,
}) => {
  const ltr = propsDirection !== "rtl";
  const val = (b: boolean) => (ltr ? b : !b);
  return (
    <Row className="sx-twoway-switch">
      <Col style={{ flex: "0 0 auto", width: "20%" }} className="form-check-label p-0">
        {ltr ? leftLabel : rightLabel}
      </Col>

      <Col style={{ flex: "0 0 auto", width: "10%", paddingLeft: 0 }}>
        <Form.Check
          type="switch"
          id={switchId}
          onChange={(e) => {
            onChange(val(e.target.checked as boolean));
          }}
          checked={val(checked)}
        />
      </Col>

      <Col className="text-center form-check-label p-0" style={{ flex: "0 0 auto", width: "20%", marginLeft: 15 }}>
        {ltr ? rightLabel : leftLabel}
      </Col>
    </Row>
  );
};

export default SXTwoWaySwitch;
